









































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import { bus } from "@/bus";
// components
import vSelect from "vue-select";
import FolderTree from "@/components/common/folders/FolderTree.vue";
// service methods
import { getChannelResolutions, getFilteredChannels } from "@/services/channels/channelsService";
import { getSolutions } from "@/services/solutions/solutionService";
// types
import { Channel, ChannelsFilterDtoIn, ChannelGroupChannel } from "@/services/channels/types";
import { Folder, FolderEntites } from "@/services/folders/types";
import { Option } from "@/services/common/types";
import { channelGroupChannelsModalFields } from "@/components/channels/fields/channelsModalFields";
import { GetLocalizedItemTypes } from "@/components/posts/PostTypeRegister";

@Component({
    components: {
        vSelect,
        "folder-tree": FolderTree
    }
})
export default class ChannelGroupAddChannelModal extends Vue {
    @Prop() sortedSeqChannels!: Array< ChannelGroupChannel>;
    // local state
    channels = [] as Array<ChannelGroupChannel>;
    selectedChannels = [] as Array<ChannelGroupChannel>;
    fields = channelGroupChannelsModalFields;
    isBusy = false;

    // folders
    folderEntity = FolderEntites.Channels;
    selectedFolderNode = {} as Folder;
    showFolderTree = true;

    // filter
    selectedSolution = null as Option | any;
    filterResolution = "" as string;
    filterPostType = "";
    // filter options
    solutions = [] as Array<Option>;
    searchText = "" as string;
    resolutions = [] as Array<String>;
    searchTimer = 0;

    open() {
        this.fetchData();
        this.$bvModal.show("channelGroupAddChannel");
    }

    setSelectedFolder(folder: Folder) {
        this.selectedFolderNode = folder;
        this.loadChannels();
    }

    toggleFolderTree() {
        if (!this.filterActive) {
            this.showFolderTree = !this.showFolderTree;
        }
    }

    save() {
        this.setSelectedChannelsArray();
        this.$emit("select", this.sortedSeqChannels.sort((x: any, y: any) => x.order - y.order));
        this.$bvModal.hide("channelGroupAddChannel");
    }

    rowSelected(items: ChannelGroupChannel[]) {
        this.selectedChannels = items;
    }

    setSelectedChannelsArray() {
        this.selectedChannels.forEach(sc => {
            if (!this.sortedSeqChannels.some(x => x.channelId === sc.channelId)) {
                this.sortedSeqChannels.push(sc);
            }
        });
        this.sortedSeqChannels = this.sortedSeqChannels.sort((x: any, y: any) => x.order - y.order);
        if (this.sortedSeqChannels.length > 0) {
            this.sortedSeqChannels.forEach(x => {
                if (x.order === null || x.order === undefined) {
                    x.order = this.sortedSeqChannels.indexOf(x);
                }
            });
        }
    }

    fetchData() {
        getSolutions().then(response => {
            this.solutions = response.map(x => ({
                id: x.id,
                text: x.name
            }));
        });
        getChannelResolutions().then(response => {
            this.resolutions = response;
        });
    }

    loadChannels() {
        this.isBusy = true;
        this.channels = [] as Array<ChannelGroupChannel>;
        getFilteredChannels({
            solutionId: this.selectedSolution ? this.selectedSolution.id : "",
            folderId: this.selectedFolderNode ? this.selectedFolderNode.id : "",
            resolution: this.filterResolution ? this.filterResolution : "",
            postType: this.filterPostType ? this.filterPostType : "",
            search: this.searchText
        } as ChannelsFilterDtoIn).then(response => {
            this.channels = response
                .map((x: Channel) => ({
                    channelId: x.id,
                    channelName: x.name,
                    width: x.width,
                    height: x.height,
                    selected: false,
                    folderId: x.folderId
                } as ChannelGroupChannel));
            this.isBusy = false;
        });
    }

    clearFilter() {
        this.selectedSolution = null;
        this.filterResolution = "";
        this.filterPostType = "";
        this.loadChannels();
    }

    clearSearch() {
        this.searchText = "";
        this.loadChannels();
    }

    resetState() {
        this.selectedSolution = null;
        this.searchText = "";
        this.filterResolution = "";
        this.filterPostType = "";
    }

    onHidden() {
        this.resetState();
        clearTimeout(this.searchTimer);
        this.channels = [];
    }

    filterText() {
        clearTimeout(this.searchTimer);
        this.searchTimer = setTimeout(() => this.loadChannels(), 1000);
    }

    // computed and watchers
    get filterActive(): boolean {
        return (
            (this.selectedSolution && Object.keys(this.selectedSolution.id).length > 0) ||
            this.searchText !== "" ||
            (!!this.filterResolution && this.filterResolution !== "") ||
            (!!this.filterPostType && this.filterPostType !== ""));
    }

    get postTypes() {
        return GetLocalizedItemTypes();
    }

    @Watch("filterActive")
    onFilterChanged(value: any, oldValue: any) {
        this.showFolderTree = !value;
    }
}
